import React, { useEffect } from 'react';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useAuth } from '../AuthContext';
import { auth } from "../Firebase/FirebaseConfig"


export default function Navbar() {

    const { isAuthenticated, logout } = useAuth();
    const navigate = useNavigate();
   
    const apiKey = process.env.REACT_APP_API_KEY;
    const baseURL = process.env.REACT_APP_BASE_URL;

    /*  const userName = localStorage.getItem('userName'); */

    /* const getAccessToken = localStorage.getItem('access_token'); */
    const getUserId = () => {
        const storedUserId = localStorage.getItem('userid');

        if (storedUserId) {
            // Use the userId from localStorage if available
            return storedUserId;
        } else {
            // Otherwise, set the userId to the default value and store it in localStorage
            const defaultUserId = 'de6e425f-5082-5b30-a279-2adce73bab98';
            localStorage.setItem('userid', defaultUserId);
            return defaultUserId;
        }
    };

    // Usage
    const userId = getUserId();
    /* console.log(userId); */


    /* const handleLogout = () => {

        logout();
        localStorage.removeItem('userid');
        navigate('/login');
    }; */



    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${baseURL}/basicdata/?userid=${userId}`, {
                    headers: {
                        accept: 'application/json',
                        Authorization: apiKey
                    }
                });


                const user = response.data.usersdata[0];
                /* localStorage.setItem('userName', user.name); */
                localStorage.setItem('ageGroupID', user.agegroupid);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        if (userId) {
            fetchData();
        }
    }, [userId, baseURL, apiKey]);

    const handleScroll = (id) => {
        setTimeout(() => {
            const element = document.getElementById(id);
            if (element) {
                const yOffset = -120;
                const yPosition = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({ top: yPosition, behavior: "smooth" });
            }
        }, 500);
    };

    useEffect(() => {
        AOS.init({
            duration: 1200,
        });
    }, []);


    const signOut = async () => {
        try {
            await auth.signOut();
            console.log("User has signed out:", auth.currentUser);
            window.location.href = "/login";  // Redirect to login page after logging out
            logout();
            localStorage.removeItem('userid');
            localStorage.removeItem('authToken');
            localStorage.removeItem('refreshToken');
            navigate('/login');
        } catch (error) {
            console.error("Error signing out:", error);
        }
    };


    return (
        <div className="main-navigation">
            <nav className="navbar navbar-expand-lg newNabvar">
                <div className="container space-container position-relative">
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 -960 960 960" width="30px" fill="#fff"><path d="M120-240v-66.67h720V-240H120Zm0-206.67v-66.66h720v66.66H120Zm0-206.66V-720h720v66.67H120Z" /></svg>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item dropdown catagories desktop-view">
                                <NavLink className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} to="/home">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="19.856" height="21.844" viewBox="0 0 19.856 21.844">
                                        <path id="Path_104854" data-name="Path 104854" d="M-760.018-465.618q0,3.095,0,6.189c0,.841-.27,1.106-1.119,1.106q-2.341,0-4.682,0c-.808,0-1.09-.278-1.092-1.1q-.007-3.531,0-7.062c0-.643,0-.643-.63-.642H-772.5c-.482,0-.521.032-.521.518,0,2.354,0,4.708,0,7.062a3.01,3.01,0,0,1-.059.628.706.706,0,0,1-.741.591q-2.618.015-5.237,0a.707.707,0,0,1-.745-.629,2.663,2.663,0,0,1-.051-.55c0-4.086,0-8.173-.007-12.259a1.549,1.549,0,0,1,.636-1.318c2.817-2.245,5.618-4.509,8.425-6.767.53-.427.82-.414,1.365.011q3,2.334,6,4.655c.969.751,1.933,1.51,2.91,2.252a1.248,1.248,0,0,1,.52,1.087C-760.025-469.771-760.018-467.694-760.018-465.618Z" transform="translate(779.869 480.166)" fill="#fff" />
                                    </svg>
                                </NavLink>
                                <ul className="dropdown-position-list">
                                    <li onClick={() => handleScroll('nutrition')}><Link to="/home">Newly Added Books</Link></li>
                                    <li onClick={() => handleScroll('recommended')}><Link to="/home">Recommended</Link></li>
                                    <li onClick={() => handleScroll('language')}><Link to="/home">Books by Language</Link></li>
                                    <li onClick={() => handleScroll('popular')}><Link to="/home">Popular Books</Link></li>
                                    <li onClick={() => handleScroll('author')}><Link to="/home">Featured Authors</Link></li>
                                    <li onClick={() => handleScroll('gener')}><Link to="/home">Books by Genre</Link></li>
                                    <li onClick={() => handleScroll('publisher')}><Link to="/home">Featured Publishers</Link></li>
                                    <li onClick={() => handleScroll('age_group')}><Link to="/home">Books by Age Groups</Link></li>
                                    {/*  <li onClick={() => handleScroll('media')}><Link to="/home">Media</Link></li>
                                    <li onClick={() => handleScroll('blog')}><Link to="/home">Blog</Link></li>
                                    <li onClick={() => handleScroll('orientation')}><Link to="/home">Orientation</Link></li> */}

                                </ul>

                            </li>
                            <div className="accordion mobile-view" id="accordionExample">
                                <div className="">

                                    <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                        <div className="accordion-body">
                                            <ul className="">
                                                <li><NavLink to="/about"  >About Us</NavLink></li>
                                                <li><Link to="/home#nutrition">Newly Added Books</Link></li>
                                                <li><Link to="/home#recommended">Recommended</Link></li>
                                                <li><Link to="/home#language">Books by Language</Link></li>
                                                <li><Link to="/home#popular">Popular Books</Link></li>
                                                <li><Link to="/home#author">Featured Authors</Link></li>
                                                <li><Link to="/home#gener">Books by Genre</Link></li>
                                                <li><Link to="/home#publisher">Featured Publishers</Link></li>
                                                <li><Link to="/home#age_group">Books by Age Groups</Link></li>
                                                <li className="nav-item">
                                                    <NavLink to="/gallery">
                                                        Gallery
                                                    </NavLink>
                                                </li>

                                                {isAuthenticated && (
                                                    <li className="nav-item">
                                                        <NavLink  to="/profile">
                                                            Profile
                                                        </NavLink>
                                                    </li>
                                                )}

                                                {isAuthenticated ? (
                                                    <li className="nav-item">
                                                        <button className='btn-6 view-all-btnn white-btnn' onClick={() => signOut()} >Logout</button>
                                                       
                                                    </li>
                                                    
                                                ) : (
                                                    <li className="nav-item">
                                                        <NavLink to="/login" >Login / Register</NavLink>
                                                    </li>
                                                )}

                                                

                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <li className="nav-item desktop-view">
                                <NavLink to="/about" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} >
                                    About Us
                                </NavLink>
                            </li>


                            <li className="nav-item desktop-view">
                                <NavLink className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} to="/gallery">
                                    Gallery
                                </NavLink>
                            </li>

                            

                            {isAuthenticated ? (
                                <>
                                <li className="nav-item desktop-view login-btn">
                                    <button onClick={() => signOut()} className="nav-link">Logout</button>
                                    {/* <button onClick={() => signOut()}>Log out me</button> */}
                                </li>
                               
                              </>
                            ) : (
                                <li className="nav-item desktop-view login-btn">
                                    <NavLink to="/login" className="nav-link">Login / Register</NavLink>
                                </li>
                            )}

                            {isAuthenticated && (
                                <li className="nav-item desktop-view">
                                    <NavLink className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} to="/profile">
                                        Profile
                                    </NavLink>
                                </li>
                            )}
                        </ul>
                        <div className="d-flex">
                            <div className="dropdown profileTabSec">
                                <button className="dropdown-toggle" type="button" id="profileTab" data-bs-toggle="dropdown" aria-expanded="false">
                                    <img src="assets/images/user.png" alt="user" />
                                    {/* <span>{userName}</span> */}
                                </button>
                                <ul className="dropdown-menu" aria-labelledby="profileTab">
                                    <li><NavLink className="dropdown-item" to="/profile">Profile</NavLink></li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

        </div>
    )
}
